// Keep mobile section titles and their action links on one line, including
// asynchronously loaded recommendations and Theme Editor section updates.
(() => {
  const selector = '.dhs-section__head, .dhs-related__head, .dhs-level-one-section__head';
  const mobile = matchMedia('(max-width: 749px)');
  const rows = new Set();
  let frame;
  const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(fit); };
  function fit() {
    for (const row of rows) {
      if (!row.isConnected) { observer.unobserve(row); rows.delete(row); continue; }
      const heading = row.querySelector('h2');
      if (!heading) continue;
      heading.style.removeProperty('--dhs-fit-heading');
      if (!mobile.matches || !heading.clientWidth) continue;
      const range = document.createRange();
      range.selectNodeContents(heading);
      const naturalWidth = range.getBoundingClientRect().width;
      const available = heading.clientWidth;
      if (naturalWidth > available) {
        const size = parseFloat(getComputedStyle(heading).fontSize);
        heading.style.setProperty('--dhs-fit-heading', `${Math.floor(size * available / naturalWidth * 10) / 10}px`);
      }
    }
  }
  const observer = new ResizeObserver(schedule);
  function discover() {
    document.querySelectorAll(selector).forEach(row => {
      if (!row.querySelector(':scope > a') || rows.has(row)) return;
      rows.add(row); observer.observe(row);
    });
    schedule();
  }
  new MutationObserver(discover).observe(document.body, { childList: true, subtree: true, characterData: true });
  mobile.addEventListener('change', schedule);
  document.fonts.ready.then(schedule);
  discover();
})();
